/***************/
/**  IMPORTS  **/
/***************/

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import settings_icon from "../assets/settings_icon.svg";
import { PageContainer,
         Header,
         Body,
         DeleteAccountButton,
         } from "../styles/SettingsStyles";

export default function SettingsPage(){

    return (
        <>
        <Navbar />
        <div style={{display: "flex", justifyContent: "center", flexDirection: "row"}}>
            <PageContainer>
                <div style={{display: "flex", flexDirection: "row", marginBottom: "50px"}}>
                    <Sidebar></Sidebar>
                    <img alt="settings_icon" src={settings_icon} style={{marginLeft: 30, paddingTop: "5px"}} />
                    <Header>Account Settings</Header>
                </div>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{display: "flex", flexDirection: "column", alignItems: "center", width: "100%"}}>
                        <DeleteAccountButton>
                                Delete My Account
                        </DeleteAccountButton>
                    </div>
                </div>
            </PageContainer>
        </div>
        </>
    )
}